import clsx from 'clsx';
import React from 'react';

import styles from './RiskIndicatorHeaders.module.scss';

interface RiskIndicatorHeadersProps {
  className?: string;
  showTechnicalQuality?: boolean;
  showEthicalQuality?: boolean;
}

export const RiskIndicatorHeaders: React.FC<RiskIndicatorHeadersProps> = ({
  className,
  showTechnicalQuality = true,
  showEthicalQuality = true,
}) => (
  <div className={clsx(styles.headers, className)}>
    {showTechnicalQuality ? <h3 className={styles.headerTitle}>Technical quality</h3> : <div />}
    {showEthicalQuality ? <h3 className={styles.headerTitle}>Ethical quality</h3> : <div />}
  </div>
);
